export const dashboard = {
    'view-all': 'View All',
    asap: 'AS SOON AS POSSIBLE',
    today: 'TODAY',
    month: 'MONTH',
    year: 'YEAR',
    'all-time': 'ALL TIME',
    this: {
      month: 'THIS MONTH',
      year: 'THIS YEAR'
    },
    'open-orders': 'Open Orders',
    'no-orders': 'No open orders',
    charts: 'SOME CHARTS'
  };